/**
 * @generated SignedSource<<154b6b53eb196a2a6f885f9fa888968c>>
 * @relayHash cf5fb840b655626332a1a7fa65052dc2
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cf5fb840b655626332a1a7fa65052dc2

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type submissionsRegistrationWasUpdatedSubscription$variables = {
  examId: string;
};
export type submissionsRegistrationWasUpdatedSubscription$data = {
  readonly registrationWasUpdated: {
    readonly registration: {
      readonly currentPin: string | null;
      readonly endTime: string | null;
      readonly final: boolean;
      readonly id: string;
      readonly over: boolean;
      readonly pinValidated: boolean;
      readonly started: boolean;
    };
  };
};
export type submissionsRegistrationWasUpdatedSubscription = {
  response: submissionsRegistrationWasUpdatedSubscription$data;
  variables: submissionsRegistrationWasUpdatedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "examId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "examId",
        "variableName": "examId"
      }
    ],
    "concreteType": "RegistrationWasUpdatedPayload",
    "kind": "LinkedField",
    "name": "registrationWasUpdated",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Registration",
        "kind": "LinkedField",
        "name": "registration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentPin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pinValidated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "started",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "over",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "final",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "submissionsRegistrationWasUpdatedSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "submissionsRegistrationWasUpdatedSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "cf5fb840b655626332a1a7fa65052dc2",
    "metadata": {},
    "name": "submissionsRegistrationWasUpdatedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "4314e5b929e47ac02335dc911c097c2c";

export default node;
